import React from 'react'
import { BoxProps, Text } from '@ui'
import { formatUnitsToFixedLength } from 'hooks/useBalance'
import { Stack } from 'ui/components/Stack/Stack'

import { formatCents, MergedTradingAsset } from '../tradingUtils'

import { TokenIcon } from './TokenIcon'

export const AssetEntry = ({
    asset,
    onClick,
    clickable = true,
    showUsdValue = true,
    ...boxProps
}: BoxProps & {
    asset: MergedTradingAsset
    clickable?: boolean
    showUsdValue?: boolean
    onClick?: (asset: MergedTradingAsset) => void
}) => {
    const pct = 1 + asset.priceChange24h
    const value24hAgo = asset.holdingValueCents / pct
    const diff24h = asset.holdingValueCents - value24hAgo

    return (
        <Stack
            horizontal
            hoverable={clickable}
            paddingX="md"
            gap="md"
            background="level1"
            rounded="sm"
            inset="xs"
            height="x7"
            cursor={clickable ? 'pointer' : 'default'}
            onClick={() => clickable && onClick?.(asset)}
            {...boxProps}
        >
            <Stack centerContent>
                <TokenIcon asset={asset} />
            </Stack>
            <Stack gap="sm" justifyContent="center">
                <Stack horizontal gap="xs" alignItems="center">
                    <Text fontWeight="strong">{asset.name}</Text>
                </Stack>

                <Text color="gray2" fontSize="sm">
                    {formatUnitsToFixedLength(BigInt(asset.balance), asset.decimals, 2)}{' '}
                    {asset.symbol}
                </Text>
            </Stack>

            <Stack grow />

            {showUsdValue && (
                <Stack gap="sm" alignItems="end" justifyContent="center">
                    <Text fontWeight="strong">{formatCents(asset.holdingValueCents)}</Text>
                    <Text color={asset.priceChange24h > 0 ? 'positive' : 'peach'}>
                        {formatCents(diff24h)}
                    </Text>
                </Stack>
            )}
        </Stack>
    )
}
